
import React, { useEffect, useState } from 'react'
import CountingText from './CountingText';
import TreemapChart from './TreemapChart';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './dashboard.css' 
import axios from 'axios';
import { API } from '../config';
import PopulationChart from './PopulationChart';

const data = {
  carts: [
    {
      title: 'Members',
      num: '8545',
    },
    {
      title: 'Well Wishers',
      num: '1200',
    },
    {
      title: 'Organisations',
      num: '20',
    },
    {
      title: 'Visitors',
      num: '20',
    },
    {
      title: 'Families',
      num: '400',
    },
    {
      title: 'Pradesh',
      num: '7',
    },
    {
      title: 'Mandals',
      num: '100',
    },
    {
      title: 'Brahmanirzar',
      num: '3300',
    },
  ],
  state: [
    {
      name: 'Ahmedabad',
      apple: 80,
      samsung: 130,
      members: 150,
      volunteers: 210
    },
    {
      name: 'Saurashtra',
      apple: 100,
      samsung: 150,
      members: 170,
      volunteers: 180
    },
    {
      name: 'Vadodara',
      apple: 80,
      samsung: 140,
      members: 160,
      volunteers: 100
    },
    {
      name: 'Kanam',
      apple: 100,
      samsung: 150,
      members: 170,
      volunteers: 123
    },
    {
      name: 'Charotar',
      apple: 50,
      samsung: 90,
      members: 110,
      volunteers: 250
    },
    {
      name: 'Surat',
      apple: 50,
      samsung: 90,
      members: 110,
      volunteers: 211
    }, {
      name: 'Kutch',
      apple: 50,
      samsung: 90,
      members: 110,
      volunteers: 50
    }, {
      name: 'Uttar Gujarat',
      apple: 50,
      samsung: 90,
      members: 110,
      volunteers: 90
    },
    {
      name: 'ROI',
      apple: 125,
      samsung: 90,
      members: 100,
      volunteers: 65
    }
  ],
  country: [
    {
      name: 'India',
      apple: 80,
      samsung: 130,
      members: 4529,
      volunteers: 210
    },
    {
      name: 'UK',
      apple: 100,
      samsung: 150,
      members: 500,
      volunteers: 380
    },
    {
      name: 'USA',
      apple: 80,
      samsung: 140,
      members: 1200,
      volunteers: 220
    },
    {
      name: 'Australia',
      apple: 100,
      samsung: 150,
      members: 240,
      volunteers: 380
    },
    {
      name: 'Canada',
      apple: 50,
      samsung: 90,
      members: 202,
      volunteers: 150
    },
    {
      name: 'ROW',
      apple: 125,
      samsung: 90,
      members: 350,
      volunteers: 65
    }
  ],
  data: [
    {
      name: "All Country",
      data: { male: "25000", female: "23000", family: "12000", kids: "5000", yuvak: "9000", yuvti: "8050", vadil: "31000", total: "48000" },
    },
    {
      name: "India",
      data: { male: "2500", female: "2300", family: "1200", kids: "500", yuvak: "900", yuvti: "850", vadil: "3100", total: "4800" },
      state: [
        {
          name: "Maharashtra",
          data: { male: "1200", female: "1100", family: "600", kids: "200", yuvak: "400", yuvti: "350", vadil: "1500", total: "2300" },
          pradesh: [
            {
              name: "Pune",
              data: { male: "600", female: "550", family: "300", kids: "100", yuvak: "200", yuvti: "180", vadil: "750", total: "1150" },
              city: [
                {
                  name: "Shivajinagar",
                  data: { male: "300", female: "270", family: "150", kids: "50", yuvak: "100", yuvti: "90", vadil: "375", total: "575" },
                  mandal: [
                    { name: "Peth Area", data: { male: "150", female: "135", family: "75", kids: "25", yuvak: "50", yuvti: "45", vadil: "190", total: "300" } },
                    { name: "Kothrud", data: { male: "150", female: "135", family: "75", kids: "25", yuvak: "50", yuvti: "45", vadil: "185", total: "275" } }
                  ]
                },
                {
                  name: "Koregaon Park",
                  data: { male: "300", female: "280", family: "150", kids: "50", yuvak: "100", yuvti: "90", vadil: "375", total: "600" },
                  mandal: [
                    { name: "North KP", data: { male: "150", female: "140", family: "75", kids: "25", yuvak: "50", yuvti: "45", vadil: "200", total: "310" } },
                    { name: "South KP", data: { male: "150", female: "140", family: "75", kids: "25", yuvak: "50", yuvti: "45", vadil: "175", total: "290" } }
                  ]
                }
              ]
            },
            {
              name: "Mumbai",
              data: { male: "600", female: "550", family: "300", kids: "100", yuvak: "200", yuvti: "180", vadil: "750", total: "1150" },
              city: [
                {
                  name: "Andheri",
                  data: { male: "300", female: "275", family: "150", kids: "50", yuvak: "100", yuvti: "90", vadil: "380", total: "600" },
                  mandal: [
                    { name: "West", data: { male: "150", female: "135", family: "75", kids: "25", yuvak: "50", yuvti: "45", vadil: "190", total: "300" } },
                    { name: "East", data: { male: "150", female: "140", family: "75", kids: "25", yuvak: "50", yuvti: "45", vadil: "185", total: "290" } }
                  ]
                },
                {
                  name: "Bandra",
                  data: { male: "300", female: "275", family: "150", kids: "50", yuvak: "100", yuvti: "90", vadil: "380", total: "600" },
                  mandal: [
                    { name: "Bandra West", data: { male: "150", female: "140", family: "75", kids: "25", yuvak: "50", yuvti: "45", vadil: "200", total: "310" } },
                    { name: "Bandra East", data: { male: "150", female: "140", family: "75", kids: "25", yuvak: "50", yuvti: "45", vadil: "175", total: "290" } }
                  ]
                }
              ]
            }
          ]
        },
        {
          name: "Gujarat",
          data: { male: "1300", female: "1200", family: "600", kids: "300", yuvak: "500", yuvti: "500", vadil: "1600", total: "2500" },
          pradesh: [
            {
              name: "Ahmedabad",
              data: { male: "700", female: "650", family: "300", kids: "150", yuvak: "250", yuvti: "250", vadil: "800", total: "1350" },
              city: [
                {
                  name: "Navrangpura",
                  data: { male: "350", female: "325", family: "150", kids: "75", yuvak: "125", yuvti: "125", vadil: "400", total: "675" },
                  mandal: [
                    { name: "East", data: { male: "175", female: "160", family: "75", kids: "35", yuvak: "65", yuvti: "60", vadil: "200", total: "325" } },
                    { name: "West", data: { male: "175", female: "165", family: "75", kids: "40", yuvak: "60", yuvti: "65", vadil: "200", total: "350" } }
                  ]
                },
                {
                  name: "Bapunagar",
                  data: { male: "350", female: "325", family: "150", kids: "75", yuvak: "125", yuvti: "125", vadil: "400", total: "675" },
                  mandal: [
                    { name: "North", data: { male: "175", female: "160", family: "75", kids: "35", yuvak: "65", yuvti: "60", vadil: "200", total: "325" } },
                    { name: "South", data: { male: "175", female: "165", family: "75", kids: "40", yuvak: "60", yuvti: "65", vadil: "200", total: "350" } }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      name: "Canada",
      data: { male: "2100", female: "1800", family: "900", kids: "200", yuvak: "800", yuvti: "600", vadil: "2300", total: "3900" },
      state: [
        {
          name: "Ontario",
          data: { male: "1200", female: "950", family: "500", kids: "120", yuvak: "400", yuvti: "320", vadil: "1300", total: "2500" },
          pradesh: [
            {
              name: "Toronto",
              data: { male: "600", female: "475", family: "250", kids: "60", yuvak: "200", yuvti: "160", vadil: "650", total: "1250" },
              city: [
                {
                  name: "Toronto",
                  data: { male: "600", female: "475", family: "250", kids: "60", yuvak: "200", yuvti: "160", vadil: "650", total: "1250" },
                  mandal: [
                    { name: "Downtown", data: { male: "300", female: "250", family: "130", kids: "30", yuvak: "100", yuvti: "80", vadil: "320", total: "620" } },
                    { name: "North York", data: { male: "300", female: "225", family: "120", kids: "30", yuvak: "100", yuvti: "80", vadil: "330", total: "630" } }
                  ]
                }
              ]
            },
            {
              name: "Ottawa",
              data: { male: "600", female: "475", family: "250", kids: "60", yuvak: "200", yuvti: "160", vadil: "650", total: "1250" },
              city: [
                {
                  name: "Ottawa",
                  data: { male: "600", female: "475", family: "250", kids: "60", yuvak: "200", yuvti: "160", vadil: "650", total: "1250" },
                  mandal: [
                    { name: "Kanata", data: { male: "300", female: "250", family: "130", kids: "30", yuvak: "100", yuvti: "80", vadil: "320", total: "620" } },
                    { name: "Nepean", data: { male: "300", female: "225", family: "120", kids: "30", yuvak: "100", yuvti: "80", vadil: "330", total: "630" } }
                  ]
                }
              ]
            }
          ]
        },
      ]
    }
  ]
}

const Dashboard = () => {

  const [counterOn, setCounterOn] = useState(false)
  const [state, setState] = useState()
  const [loading, setLoading] = useState()
  const [dashboardData, setDashboardData] = useState()

  const [allCountry, setAllCountry] = useState()
  const [selectCountry, setSelectedCountry] = useState('All Country')

  const [allState, setAllState] = useState()
  const [selectdState, setSelectedState] = useState('')

  const [allPradesh, setAllPradesh] = useState()
  const [selectdPradesh, setSelectedPradesh] = useState('')

  const [allCity, setAllCity] = useState()
  const [selectdCity, setSelectedCity] = useState('')

  const [allMandal, setAllMandal] = useState()
  const [selectdMandal, setSelectedMandal] = useState('')

  const [grafAllData, setGrafAllData] = useState()
  const [grafData, setGrafData] = useState()


  useEffect(() => {
    AOS.init({ duration: 2000 });
  }, [])
  const getDashboardData = async () => {
    setLoading(true)
    try {
      const response = await fetch(`${API}?action=dashboard&format=new`, {
        method: 'GET',
        headers: {
          Accept: '*/*',
          'content-type': 'application/json'
        },
      })
      const data = await response.json()
      if (!response.ok) {
        throw new Error(data?.messge || "fild to fetch data")
      }
      if (data) {
        setDashboardData(data)
      }
    } catch (err) {
      setLoading(false)
    }
  }
  useEffect(() => {
    getDashboardData()
  }, [])

  useEffect(() => {
    setAllCountry(data?.data?.map?.((el) => el?.name))
  }, [data])
  useEffect(() => {
    if (selectCountry) {
      let country = data?.data?.filter((el) => el?.name == selectCountry)
      setGrafAllData(country)
      setGrafData(country?.[0]?.data)
      setAllState(country?.[0]?.state)
    }
  }, [selectCountry, data])

  useEffect(() => {
    if (selectdState) {
      let state = grafAllData?.data?.filter((el) => el?.name == selectdState)
      setGrafData(state?.[0]?.data)
      setAllPradesh(state?.[0]?.pradesh)
    }
  }, [grafAllData, selectdState])


  console.log(grafAllData);
  console.log(grafData);
  console.log(selectdState);
  console.log(allState);
  console.log(selectdState);
  console.log(allPradesh);
  console.log(selectdPradesh);


  // console.log(selectCountry);


  return (
    <div style={{ width: '95%', margin: 'auto' }}>

      <div class='dashCart rounded-4  '>
        {
          data?.carts?.map((el) => {
            return (
              <div data-aos="zoom-in-up">
                <div class='col-11 m-auto topCarts p-2 rounded-4 mt-4'>
                  <div class='col-11 m-auto text-start my-1'>
                    <p class=' fs-4   '>{(el?.title)}</p>
                    <p class='fs-1  fw-bold '><CountingText key={el?.num} num={el?.num == null ? 0 : el?.num} /></p>
                  </div>
                </div>
              </div>
            )
          })
        } 
      </div> 

      <div class='dashContCart mt-4'>
        <div class='' data-aos="zoom-in">
          <div class='  m-auto text-start  bg-white rounded-4'>
            <br />
            <div class='col-11 m-auto '>
              <TreemapChart state={data?.state} name={"Pradeshwise Volunteers"} color={"#11C0FE"} />
            </div>
          </div>
        </div>
        <div class='' data-aos="zoom-in">
          <div class='  m-auto text-start  bg-white rounded-4'>
            <br />
            <div class='col-11 m-auto '>
              <TreemapChart state={data?.country} name={"Members Worldwide"} color={"#034DA2"} />
            </div>
          </div>
        </div>
      </div>

    
      <div style={{width:'100%', margin: '25px 0'}} class='rounded-4 bg-white'  data-aos="zoom-in">
        <div class=' p-3 text-start '>
          <br />  
          <p class='fw-semibold'>Population Distribution by Age Groups & Gender </p>
          <PopulationChart data={data?.data} /> 
        </div>
      </div>
    
      <br />
    </div>
  )
}

export default Dashboard